module.exports = __webpack_public_path__ + "media/images/icons/gear-outline-2d05f0266b97f5dd3b30e17c03244e90.svg";